module.exports = __webpack_public_path__ + "static/media/104faces.2d56bb64.gif";